import ModalFrame from '@/components/common/ModalFrame';
import styled from 'styled-components';
import WarningIcon from '../../assets/departureWifi/icon_warning.png';
import { ICON_CHECK_WHITE } from '@repo/assets';

type TicketUploadModalProps = {
  onClose: () => void;
  isFail?: boolean;
};

function TicketUploadModal({
  onClose,
  isFail = false,
}: TicketUploadModalProps) {
  const TitleIcon = isFail ? WarningIcon : ICON_CHECK_WHITE;
  const TitleText = isFail ? '항공권 업로드 실패' : '항공권 업로드 완료';
  const BodyText = isFail ? (
    <>
      일시적인 네트워크 오류로 인해
      <br />
      항공권 업로드에 실패했습니다.
      <br />
      다시 업로드해주세요.
    </>
  ) : (
    <>
      항공권 확인 후 송금 예정입니다.
      <br />
      출국 이후 14일 이내 송금이 완료됩니다.
    </>
  );

  return (
    <ModalFrame
      title={
        <TitleWrapper>
          <img src={TitleIcon} alt='' width={20} height={20} />
          <Title>{TitleText}</Title>
        </TitleWrapper>
      }
      content={
        <Content>
          <Description>{BodyText}</Description>
          {isFail || (
            <SubDescription>
              *항공권 재업로드가 필요할 경우
              <br />
              요청드릴 수 있습니다.
            </SubDescription>
          )}
        </Content>
      }
      buttons={<Button onClick={onClose}>확인</Button>}
    />
  );
}

const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 16px;
`;
const Title = styled.strong`
  font-size: 16px;
  font-weight: 600;
  color: #030303;
`;

const Button = styled.button`
  width: 100%;
  height: 48px;
  border-radius: 8px;
  background-color: #246cf6;
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  margin-top: 16px;
`;

const Content = styled.div`
  display: flex;
  align-content: center;
  justify-content: center;
  flex-direction: column;
  gap: 16px;
  text-align: center;
`;

const Description = styled.p`
  font-size: 14px;
  font-weight: 500;
  color: #5f6165;
  line-height: 21px;
`;

const SubDescription = styled.p`
  font-size: 13px;
  font-weight: 400;
  color: #80848a;
  line-height: 19.5px;
`;

export default TicketUploadModal;
